import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Button, Chip, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, InputAdornment, Radio, RadioGroup, TextField } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import GlobalDialogContent from '../GlobalDialogContent';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { useState } from 'react';
import { StoreFundDisbursement } from '../../../utils/services/project/project';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { AmountDisplay } from '../../../utils/utils';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
const AddDisbursment = () => {
    const { payload } = useSelector((state: RootState) => state.dialog);
    const [buttonLoader, setbuttonLoader] = useState(false);
    const [fileInputKey, setFileInputKey] = useState(Date.now()); 
    const dispatch = useDispatch();
    const RemainingAmount: number = Number(payload?.amount.fund_allocated) - Number(payload?.amount.fund_disbursed);
    const formik = useFormik({
        initialValues: {
            project_name: payload.project_name,
            agnecy_name: payload.agency_name,
            date: dayjs(),
            amount: Number(payload.amount || 0)?.toFixed(0),
            remark: '',
            utrNo: '',
            attachment: null as File | null,
            paymentMode: "RTGS",
        },
        validationSchema: Yup.object().shape({
            date: Yup.date().required('Date is required'),
            amount: Yup.number().required('Amount is required').positive('Amount must be positive')
                .max(payload.amount, `Amount can't be greater than ${payload.amount}`),
            remark: Yup.string(),
            utrNo: Yup.string()
            .required('UTR No is required')
            .matches(/^[0-9]{9,22}$/, 'UTR number must be between 9 and 22 digits'),
            paymentMode: Yup.string().required("Please select a payment mode"),
            attachment: Yup.mixed<File>().nullable()
            .required('Attachment is required')
            .test("fileSize", "File size must be less than 5MB", (file: any) => { return file && file.size <= 5 * 1024 * 1024; })
            .test("fileType", "Only PDF, JPG, and PNG files are allowed", (file: any) => { return (file && ["application/pdf", "image/jpeg", "image/png", "image/jpg"].includes(file.type)); }),
        }), 
        onSubmit: async (values) => {
            setbuttonLoader(true);
            const formData = new FormData();
            formData.append("distribution_id", payload?.disb_id);
            formData.append("agency_user_id", payload?.agency_id);
            formData.append("disbursement_date", dayjs(values?.date).format("YYYY-MM-DD"));
            formData.append("amount", values?.amount.toString());
            formData.append("utr_number", values?.utrNo);
            formData.append("documents", values?.attachment || '');
            formData.append("remarks", values?.remark);
            formData.append("payment_mode", values?.paymentMode);

            const { code, message } = await StoreFundDisbursement(formData);

            if (code === 200) {
                dispatch(closeDialog());
                setbuttonLoader(false);
                dispatch(setModuleRefresh({ moduleName: 'StoreDisbursement', refresh: true }));
                dispatch(showSnackbar({ type: "success", message: message || "Status updated successfully!" }));
            } else {
                setbuttonLoader(false);
                dispatch(showSnackbar({ type: "error", message: message || "Failed to update status" }));
            }

        },
    });

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        fieldName: string
    ) => {
        const file = event.target.files?.[0];
        if (!file) return;
    
        const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
        const maxSize = 5 * 1024 * 1024;
    
        if (!allowedTypes.includes(file.type)) {
            dispatch(showSnackbar({ type: 'error', message: 'Only PDF, JPG, and PNG files are allowed.' }));
            event.target.value=''
            return;
        }
    
        if (file.size > maxSize) {
            dispatch(showSnackbar({ type: 'error', message: "File size should not exceed 5MB." }));
            event.target.value=''
            return;
        }
    
        formik.setFieldValue(fieldName, file);
    };

    return (
        <Box component="div" sx={{ bgcolor: 'background.default' }}>
            <GlobalDialogContent
                dialogBody={
                    <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Project Name"
                                        name="hospitalName"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.project_name}
                                        placeholder="Project Name"
                                        size="small"
                                        fullWidth
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Implementing Agency Name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.agnecy_name}
                                        placeholder="Implementing Agency Name"
                                        size="small"
                                        fullWidth
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={formik.values.date ? dayjs(formik.values.date) : null}
                                        onChange={(value) =>
                                            formik.setFieldValue("date", value ? value.toDate() : null)
                                        }
                                        sx={{ ".MuiButtonBase-root": { marginRight: 0 } }}
                                        format="DD-MM-YYYY"
                                        maxDate={dayjs()}
                                        slotProps={{
                                            textField: {
                                                label: 'Disbursement Date',
                                                placeholder: "Select Date",
                                                fullWidth: true,
                                                size: "small",
                                                inputProps: { style: { textOverflow: "ellipsis" } },
                                                error: formik.touched.date && Boolean(formik.errors.date),
                                                helperText:
                                                    formik.touched.date && typeof formik.errors.date === "string"
                                                        ? formik.errors.date
                                                        : "",
                                            },
                                        }}
                                    />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        label="Disbursement Amount"
                                        autoComplete='off'
                                        name="amount"
                                        value={AmountDisplay(Number(formik.values.amount))}
                                        placeholder='Enter Disbursement Amount'
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9.]/g, '');
                                            const digitCount = value.replace('.', '').length;
                                            if (digitCount <= 10) {
                                                formik.setFieldValue('amount', value);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.amount && Boolean(formik.errors.amount)}
                                        helperText={
                                            formik.touched.amount && typeof formik.errors.amount === 'string'
                                                ? formik.errors.amount
                                                : ''
                                        }
                                        size="small"
                                        fullWidth
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="end" sx={{ mr: 2 }}>
                                                    ₹
                                                </InputAdornment>
                                            ),
                                        }}
                                        inputProps={{ style: { textAlign: 'right' } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        name="utrNo"
                                        label="UTR No."
                                        autoComplete='off'
                                        value={formik.values.utrNo}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                            if (value.length <= 22) {
                                                formik.setFieldValue('utrNo', value);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.utrNo && Boolean(formik.errors.utrNo)}
                                        helperText={formik.touched.utrNo && formik.errors.utrNo}
                                        placeholder="Enter UTR number"
                                        size="small"
                                        fullWidth
                                        inputProps={{ maxLength: 22, style: { textAlign: 'right' } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Box>
                                        <input
                                            accept=".pdf,.jpg,.png"
                                            id="upload-file"
                                            type="file"
                                            style={{ display: 'none' }}
                                            onChange={(event) =>
                                                handleFileChange(event, 'attachment')
                                            }
                                            key={fileInputKey} // Added key to reset file input
                                        />
 
                                        {!formik.values.attachment && (
                                            <label htmlFor="upload-file">
                                                <Button variant="outlined" sx={{ p: 1, mb: 1 }} component="span" size="small" fullWidth>
                                                    Upload Attachment
                                                </Button>
                                            </label>
                                        )}
                                        {formik.touched.attachment && formik.errors.attachment && (
                                            <FormHelperText error>
                                                {typeof formik.errors.attachment === 'string' ? formik.errors.attachment : ''}
                                            </FormHelperText>
                                        )}
                                        {formik.values.attachment && (
                                            <>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <Chip
                                                        label={formik.values.attachment?.name}
                                                        sx={{ maxWidth: 200 }}
                                                        color="primary"
                                                        variant="outlined"
                                                        onDelete={() => {
                                                            formik.setFieldValue('attachment', null);
                                                            setFileInputKey(Date.now()); // Reset file input
                                                        }}
                                                    />
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl
                                        component="fieldset"
                                        error={formik.touched.paymentMode && Boolean(formik.errors.paymentMode)}
                                    >
                                        <FormLabel component="legend">Mode of Payment</FormLabel>
                                        <RadioGroup
                                            row
                                            name="paymentMode"
                                            value={formik.values.paymentMode}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            {["RTGS", "NEFT", "IMPS", "UPI", "Cheque", "Other"].map((mode) => (
                                                <FormControlLabel
                                                    key={mode}
                                                    value={mode}
                                                    control={<Radio />}
                                                    label={mode}
                                                />
                                            ))}
                                        </RadioGroup>
                                        <FormHelperText>
                                            {formik.touched.paymentMode && formik.errors.paymentMode}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="remark"
                                        value={formik.values.remark}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.remark && Boolean(formik.errors.remark)}
                                        helperText={formik.touched.remark && formik.errors.remark}
                                        placeholder="Enter Remarks"
                                        multiline
                                        rows={3}
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </FormikProvider>
                }
                dialogFooter={
                    <Button disabled={buttonLoader} onClick={() => formik.handleSubmit()} type="submit" variant="contained" color="success" endIcon={<CheckCircleOutline />}>
                        Disburse
                    </Button>
                }
            />
        </Box>
    );
};

export default AddDisbursment;
